import { Plan } from '@cel_cash/core/types'

type Locale = {
    [key in Plan['periodicity']]: string
}

export const periodicidade: Locale = {
    weekly: 'Semanal',
    biweekly: 'Quinzenal',
    monthly: 'Mensal',
    bimonthly: 'Bimestral',
    quarterly: 'Trimestral',
    yearly: 'Anual',
    biannual: 'Bianual',
}
